// @ts-expect-error
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import computeMd5 from "blueimp-md5";
import * as FileSystem from "expo-file-system/legacy";
// @ts-expect-error
import { Parser } from "m3u8-parser";
import { Platform } from "react-native";
export function getVTTFromM3u8Uri(manifestUri) {
    return _getVTTFromM3u8Uri.apply(this, arguments);
}
function _getVTTFromM3u8Uri() {
    _getVTTFromM3u8Uri = _async_to_generator(function(manifestUri) {
        var _Object_values_, _subtitleParser_manifest_segments, _subtitleParser_manifest, manifest, parser, _parser_manifest_mediaGroups_SUBTITLES, _Object_values_1, subtitlesUri, subtitlesManifest, subtitleParser, _subtitleParser_manifest_segments_map, subtitleVttUris, vtts, startMillisSet;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(manifestUri)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().text()
                    ];
                case 2:
                    manifest = _state.sent();
                    parser = new Parser();
                    parser.push(manifest);
                    parser.end();
                    subtitlesUri = (_Object_values_ = Object.values((_Object_values_1 = Object.values((_parser_manifest_mediaGroups_SUBTITLES = parser.manifest.mediaGroups.SUBTITLES) !== null && _parser_manifest_mediaGroups_SUBTITLES !== void 0 ? _parser_manifest_mediaGroups_SUBTITLES : {})[0]) !== null && _Object_values_1 !== void 0 ? _Object_values_1 : {})[0]) === null || _Object_values_ === void 0 ? void 0 : _Object_values_.uri;
                    if (!subtitlesUri) {
                        return [
                            2,
                            {
                                captions: []
                            }
                        ];
                    }
                    return [
                        4,
                        fetch(subtitlesUri)
                    ];
                case 3:
                    return [
                        4,
                        _state.sent().text()
                    ];
                case 4:
                    subtitlesManifest = _state.sent();
                    subtitleParser = new Parser();
                    subtitleParser.push(subtitlesManifest);
                    subtitleParser.end();
                    subtitleVttUris = (_subtitleParser_manifest_segments_map = subtitleParser === null || subtitleParser === void 0 ? void 0 : (_subtitleParser_manifest = subtitleParser.manifest) === null || _subtitleParser_manifest === void 0 ? void 0 : (_subtitleParser_manifest_segments = _subtitleParser_manifest.segments) === null || _subtitleParser_manifest_segments === void 0 ? void 0 : _subtitleParser_manifest_segments.map(function(s) {
                        return s.uri;
                    })) !== null && _subtitleParser_manifest_segments_map !== void 0 ? _subtitleParser_manifest_segments_map : [];
                    return [
                        4,
                        Promise.all(subtitleVttUris.map(/*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(uri) {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fetch(uri)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent().text()
                                            ];
                                    }
                                });
                            });
                            return function(uri) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 5:
                    vtts = _state.sent();
                    // When combining VTTs from distinct files in a m3u8 manifest, it's possible that some timestamps
                    // are duplicated
                    startMillisSet = new Set();
                    return [
                        2,
                        vtts.map(parseVTT).reduce(function(carry, vtt) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = vtt.captions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var caption = _step.value;
                                    if (!startMillisSet.has(caption.startMillis)) {
                                        startMillisSet.add(caption.startMillis);
                                        carry.captions.push(caption);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return carry;
                        }, {
                            captions: []
                        })
                    ];
            }
        });
    });
    return _getVTTFromM3u8Uri.apply(this, arguments);
}
// '00:00:01.040' => number
function timestampToMillis(timestamp) {
    var _timestamp_split_map = _sliced_to_array(timestamp.split(':').map(function(str) {
        return Number.parseFloat(str);
    }), 3), hours = _timestamp_split_map[0], minutes = _timestamp_split_map[1], seconds = _timestamp_split_map[2];
    var totalSeconds = hours * 60 * 80 + minutes * 60 + seconds;
    return totalSeconds * 1000;
}
function parseVTT(text) {
    var captions = [];
    text = text.replace(/\r/g, '');
    var parts = text.split('\n\n');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            var _part_match;
            if (part.startsWith('WEBVTT') || part.startsWith('NOTE')) continue;
            var _part_match_index;
            var timestampStartIndex = (_part_match_index = (_part_match = part.match(/\d\d:/)) === null || _part_match === void 0 ? void 0 : _part_match.index) !== null && _part_match_index !== void 0 ? _part_match_index : 0;
            var _part_slice_split = _to_array(part.slice(timestampStartIndex).split('\n')), timestamps = _part_slice_split[0], texts = _part_slice_split.slice(1);
            if (timestamps.includes(' --> ')) {
                var _timestamps_split = _sliced_to_array(timestamps.split(' --> '), 2), start = _timestamps_split[0], end = _timestamps_split[1];
                captions.push({
                    startMillis: timestampToMillis(start),
                    endMillis: timestampToMillis(end),
                    caption: texts.join('\n').replace(/\&nbsp;/g, ' ')// i think these <v> blocks are to identify speakers. Sometimes they put the speaker names
                    // other times they use a placeholder "-"
                    .replace(/\<v [\w-]*\>/, '').replace(/\<\/v\>/, '')
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        captions: captions
    };
}
// copied from MediaPlayer to prevent circular reference
function getCachedUri(uri) {
    if (Platform.OS === 'web' || typeof uri === 'number') return null;
    var extension = uri.split('.').reverse()[0];
    var hash = computeMd5(uri);
    return "".concat(FileSystem.documentDirectory, "mediaplayer-preload/").concat(hash, ".").concat(extension);
}
function preloadMedia(uri) {
    return _preloadMedia.apply(this, arguments);
}
function _preloadMedia() {
    _preloadMedia = _async_to_generator(function(uri) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (Platform.OS === 'web') return [
                        2
                    ];
                    return [
                        4,
                        FileSystem.makeDirectoryAsync("".concat(FileSystem.documentDirectory, "mediaplayer-preload"), {
                            intermediates: true
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        FileSystem.downloadAsync(uri, getCachedUri(uri))
                    ];
            }
        });
    });
    return _preloadMedia.apply(this, arguments);
}
export function parseRemoteVTT(uri) {
    return _parseRemoteVTT.apply(this, arguments);
}
function _parseRemoteVTT() {
    _parseRemoteVTT = _async_to_generator(function(uri) {
        var res, sourceUri, exists, data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(Platform.OS === 'web')) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetch(uri)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.text()
                    ];
                case 2:
                    return [
                        2,
                        parseVTT.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 3:
                    sourceUri = getCachedUri(uri);
                    return [
                        4,
                        FileSystem.getInfoAsync(sourceUri)
                    ];
                case 4:
                    exists = _state.sent().exists;
                    if (!!exists) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        preloadMedia(uri)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        FileSystem.readAsStringAsync(sourceUri)
                    ];
                case 7:
                    data = _state.sent();
                    return [
                        2,
                        parseVTT(data)
                    ];
            }
        });
    });
    return _parseRemoteVTT.apply(this, arguments);
}
export function getVTTTranscript(vttOrM3u8Uri) {
    return _getVTTTranscript.apply(this, arguments);
}
function _getVTTTranscript() {
    _getVTTTranscript = _async_to_generator(function(vttOrM3u8Uri) {
        var vtt;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        vttOrM3u8Uri.endsWith('.vtt') ? parseRemoteVTT(vttOrM3u8Uri) : getVTTFromM3u8Uri(vttOrM3u8Uri)
                    ];
                case 1:
                    vtt = _state.sent();
                    return [
                        2,
                        vtt.captions.map(function(cap) {
                            return cap.caption.replace(/\r/g, ' ').replace(/\n/g, ' ').trim();
                        })
                    ];
            }
        });
    });
    return _getVTTTranscript.apply(this, arguments);
}
